module.exports = __webpack_public_path__ + "static/media/Upload_Icon.f9db7223.svg";